import React, { useEffect, useState } from 'react';
import { useDialog } from '../common/useDialog';
import { usePopPresence, MODAL_CLOSE_MS } from '../common/usePopTransition';
import './ConfirmModal.css';

/**
 * A dialog with one text box, drawn like ConfirmModal (the same overlay, card, field and buttons). `onConfirm` gets what
 * was typed; Enter confirms, Escape and a click outside cancel. Used through promptAsync() (utils/notify.js).
 */
const PromptModal = ({
  open,
  title,
  message = '',
  label = '',
  placeholder = '',
  defaultValue = '',
  confirmLabel = 'OK',
  closeLabel = 'Cancel',
  onConfirm,
  onClose
}) => {
  const [value, setValue] = useState(defaultValue);
  // Each time it opens it starts from the value the caller gave.
  useEffect(() => {
    if (open) setValue(defaultValue);
  }, [open, defaultValue]);

  const dialogRef = useDialog(open, onClose);
  const pop = usePopPresence({ title, message, label, placeholder, confirmLabel, closeLabel }, open, MODAL_CLOSE_MS);
  if (!pop.mounted) return null;
  const shown = pop.value;

  return (
    <div
      ref={dialogRef}
      className={`confirm-modal-overlay ui-modal-backdrop${pop.closing ? ' is-closing' : ''}`}
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="prompt-modal-title"
    >
      <form
        className="confirm-modal-content ui-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => { e.preventDefault(); onConfirm(value); }}
      >
        <h3 id="prompt-modal-title" className="confirm-modal-title">{shown.title}</h3>
        {shown.message ? <p className="confirm-modal-message">{shown.message}</p> : null}
        <div className="confirm-modal-note">
          <label htmlFor="prompt-modal-input">{shown.label || shown.title}</label>
          <input
            id="prompt-modal-input"
            type="text"
            className="confirm-modal-phrase"
            value={value}
            placeholder={shown.placeholder}
            onChange={(e) => setValue(e.target.value)}
            autoComplete="off"
            autoFocus
          />
        </div>
        <div className="confirm-modal-actions">
          <button type="submit" className="btn btn-primary">{shown.confirmLabel}</button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>{shown.closeLabel}</button>
        </div>
      </form>
    </div>
  );
};

export default PromptModal;
